import React,{useState} from 'react'
import { X, Sparkles, ChevronLeft, ChevronRight } from 'lucide-react';
import Classic1 from '../../assets/image/Classic1.png'
import Classic2 from '../../assets/image/Classic2.png'
import Classic3 from '../../assets/image/Classic3.png'
import Classic4 from '../../assets/image/Classic4.png'
import Classic5 from '../../assets/image/Classic5.png'
import Modern1 from '../../assets/image/Modern1.png'
import Modern2 from '../../assets/image/Modern2.png'
import Modern3 from '../../assets/image/Modern3.png'
import Modern4 from '../../assets/image/Modern4.png'
import Modern5 from '../../assets/image/Modern5.png'
import Wave1 from '../../assets/image/Wave1.png'
import Wave2 from '../../assets/image/Wave2.png'
import Wave3 from '../../assets/image/Wave3.png'
import Wave4 from '../../assets/image/Wave4.png'
import Wave5 from '../../assets/image/Wave5.png'

const templates = [
  {
    name: 'Classic',
    // description: 'Traditional and formal',
    gradient: 'from-blue-900 to-blue-700',
    accentColor: '#3b82f6',
    images: [Classic1,Classic2,Classic3,Classic4,Classic5]
  },
  {
    name: 'Modern',
    // description: 'Clean and minimalist',
    gradient: 'from-slate-900 to-slate-700',
    accentColor: '#64748b',
    images: [Modern1,Modern2,Modern3,Modern4,Modern5]
  },
  {
    name: 'Wave',
    // description: 'Beautiful tables wave style',
    gradient: 'from-emerald-900 to-teal-700',
    accentColor: '#1abc9c',
    images: [Wave5,Wave2,Wave3,Wave4,Wave1]
  }
];

const Showcase = () => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleOpenModal = (template) => {
    setSelectedTemplate(template);
    setCurrentImageIndex(0);
  };

  const handleCloseModal = () => {
    setSelectedTemplate(null);
    setCurrentImageIndex(0);
  };

  const handleNextImage = () => {
    if (selectedTemplate) {
      setCurrentImageIndex((prev) => (prev + 1) % selectedTemplate.images.length);
    }
  };

  const handlePrevImage = () => {
    if (selectedTemplate) {
      setCurrentImageIndex((prev) =>
        prev === 0 ? selectedTemplate.images.length - 1 : prev - 1
      );
    }
  };
  return (
    <section className="relative px-6 py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black" />

      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/2 right-1/4 w-[600px] h-[600px] bg-[#1abc9c] rounded-full blur-[150px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Designed to
            <span className="gradient-text"> Impress</span>
          </h2>
          <p className="text-xl text-white/60 max-w-2xl mx-auto">
            Choose a look that matches your brand. From minimalist to premium.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 justify-center">
          {templates.map((template, index) => (
            <div
              key={index}
              className={index==2?"mt-[40px] md:mt-0 group cursor-pointer transition-all duration-500 hover:-translate-y-2":"group cursor-pointer transition-all duration-500 hover:-translate-y-2"}
              style={{
                transform: `translateY(${index % 2 === 0 ? '0' : '20px'})`,
              }}
              onClick={() => handleOpenModal(template)}
            >
              <div className="glass-card rounded-3xl p-6 h-full hover:bg-white/10 transition-all duration-500 shadow-[0_20px_60px_rgba(26,188,156,0.15)] md:shadow-none md:hover:shadow-[0_20px_60px_rgba(26,188,156,0.3)]">
                <div className="rounded-2xl aspect-[3/4] mb-6 relative overflow-hidden group-hover:scale-105 transition-transform duration-500">
                  <img
                    src={template.images[0]}
                    alt={template.name}
                    className="w-full h-full object-cover p-1"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <span className="text-white font-semibold text-lg bg-black/50 backdrop-blur-sm px-6 py-3 rounded-full">
                      View Gallery
                    </span>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#1abc9c] transition-colors duration-300">
                  {template.name}
                </h3>
                <p className="text-white/60">{template.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedTemplate && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm animate-fade-in"
          onClick={handleCloseModal}
        >
          <button
            onClick={handleCloseModal}
            className="absolute top-4 right-4 md:top-8 md:right-8 p-3 rounded-full glass-effect hover:bg-white/20 transition-all duration-300 z-10"
          >
            <X className="w-6 h-6 text-white" />
          </button>

          <div
            className="relative max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="glass-card rounded-3xl p-4 md:p-8">
              <div className="mb-6">
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                  {selectedTemplate.name}
                </h3>
                <p className="text-white/60">{selectedTemplate.description}</p>
              </div>

              <div className="relative group">
                <div className="rounded-2xl overflow-hidden bg-black/20">
                  <img
                    src={selectedTemplate.images[currentImageIndex]}
                    alt={`${selectedTemplate.name} - Image ${currentImageIndex + 1}`}
                    className="w-full h-auto max-h-[60vh] object-contain"
                  />
                </div>

                {selectedTemplate.images.length > 1 && (
                  <>
                    <button
                      onClick={handlePrevImage}
                      className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 p-2 md:p-3 rounded-full bg-black/50 backdrop-blur-sm hover:bg-black/70 transition-all duration-300 opacity-0 group-hover:opacity-100"
                    >
                      <ChevronLeft className="w-5 h-5 md:w-6 md:h-6 text-white" />
                    </button>
                    <button
                      onClick={handleNextImage}
                      className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 p-2 md:p-3 rounded-full bg-black/50 backdrop-blur-sm hover:bg-black/70 transition-all duration-300 opacity-0 group-hover:opacity-100"
                    >
                      <ChevronRight className="w-5 h-5 md:w-6 md:h-6 text-white" />
                    </button>
                  </>
                )}
              </div>

              {selectedTemplate.images.length > 1 && (
                <div className="flex justify-center gap-2 mt-6">
                  {selectedTemplate.images.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImageIndex(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentImageIndex
                          ? 'bg-[#1abc9c] w-8'
                          : 'bg-white/30 hover:bg-white/50'
                      }`}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Showcase